import axios from "axios";
import { Base_URL } from "../url";

export const saveItemGroup1 = async (itemGroupData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ItemGroup1/CreateItemGroup1?UserName=${userName}`,
      itemGroupData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving item group 1 details!";
  }
};

export const getAllItemGroups = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ItemGroupMaster/GetAllItemGroups`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching item groups!";
  }
};